import React from 'react';
import ManageServices from '../ManageServices';

const ServicesCategoriesSettings = () => <ManageServices />;

export default ServicesCategoriesSettings;
